import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { RootState } from "app/lib/store/store";
import { useDispatch, useSelector } from "react-redux";
import {
  nextStep,
  prevStep,
  addStepsData,
} from "app/lib/store/slices/steps/loanTypesSteps";

import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import SubTitle from "app/components/common/typography/SubTitle";
import DynamicFormOne from "app/components/Individual/applicant/personalDetails/DynamicFormOne";
import { PersonalInfoFormStepOne } from "app/utils/applicant/types/types";

const PersonalDetailsPartOne: React.FC = () => {
  const dispatch = useDispatch();
  const { applicants, ...remaingData } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<PersonalInfoFormStepOne>();

  const onSubmit = (data: PersonalInfoFormStepOne) => {
    const { firstName, lastName, dateOfBirth, email } = data;
    dispatch(
      addStepsData({
        ...remaingData,
        applicants: {
          ...applicants,
          firstName: firstName,
          lastName: lastName,
          dateOfBirth,
          email: email?.toLowerCase(),
        },
      })
    );
    dispatch(nextStep());
  };

  useEffect(() => {
    if (applicants) {
      reset({
        firstName: applicants.firstName,
        lastName: applicants.lastName,
        dateOfBirth: applicants.dateOfBirth,
        email: applicants.email,
      });
    }
  }, [applicants, reset]);

  const fields: any = [
    {
      type: "text",
      name: "firstName",
      label: "First Name",
      placeholder: "Caroline",
      className: "flex-1",
      required: true,
      rules: {
        required: "First name is required",
        pattern: {
          value: /^[A-Za-z\s]+$/,
          message: "Only alphabets are allowed",
        },
      },
    },
    {
      type: "text",
      name: "lastName",
      label: "Last Name",
      placeholder: "Jamees",
      className: "flex-1",
      required: true,
      rules: {
        required: "Last name is required",
        pattern: {
          value: /^[A-Za-z\s]+$/,
          message: "Only alphabets are allowed",
        },
      },
    },
    {
      type: "date",
      name: "dateOfBirth",
      label: "Date Of Birth",
      placeholder: "DD/MM/YYYY",
      className: "flex-1",
      rules: {
        required: "Date is required",
      },
      validateAge: true,
      maxDate: true,
    },
    {
      type: "text",
      name: "email",
      label: "Email address",
      className: "flex-1",
      placeholder: "Caroline325@mail.com",
      required: true,
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format",
        },
      },
    },
  ];

  return (
    <>
      <ProgressBar progress={60} />
      <div className="w-full  sm:w-[70%] xl:w-[40%]  mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Personal Details" />
        <SubTitle title="Please enter the required information below" />
        <form onSubmit={handleSubmit(onSubmit)}>
          <DynamicFormOne fields={fields} control={control} errors={errors} />
          <div className="flex justify-between my-10">
            <PreviousButtom onClick={() => dispatch(prevStep())}>
              Previous
            </PreviousButtom>
            <ContinueButton type="submit">Next</ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default PersonalDetailsPartOne;
